import DARSHAN_LOGO from "../assets/darshanLogo";
import SMIT_LOGO from "../assets/smitLogo";

/**
 * TopBrandBar — Garment ERP (Darshan Uniforms build).
 *
 * Always-white strip pinned to the very top of the app shell. Stays white in
 * BOTH light and dark mode by design: the Darshan Uniforms logo has dark navy
 * lettering that disappears on a dark background, and a fixed brand surface
 * across themes is how most product UIs carry client branding.
 *
 * Layout (~46px tall):
 *   ┌─────────────────────────────────────────────────────────────────────┐
 *   │  [DARSHAN LOGO] │ GARMENT ERP                   DEVELOPED BY [SMIT] │
 *   │                 │ Production · Inventory · Billing                  │
 *   ├─────────────────────────────────────────────────────────────────────┤  ← thin brand stripe
 *
 * Left is the CLIENT and the product, right is the DEVELOPER. No
 * `position: sticky` is needed — the App root is a fixed-height flex column,
 * so the bar is naturally pinned above the scrollable <main>.
 */

// Brand gradient sampled from the SMIT artwork (orange top → crimson bottom).
const BRAND_FROM = "#F0590F";
const BRAND_TO = "#FC173F";

export default function TopBrandBar() {
    return (
        <div style={{
            flexShrink: 0,
            background: "linear-gradient(180deg, #FFFFFF 0%, #FCFAF7 100%)",
            borderBottom: "1px solid #E8E2D8",
            boxShadow: "0 1px 0 rgba(0,0,0,0.02), 0 2px 4px rgba(0,0,0,0.03)",
            position: "relative",
        }}>
            <div style={{
                height: 46,
                display: "flex", alignItems: "center",
                padding: "0 18px",
                gap: 14,
            }}>
                {/* Client logo */}
                <img src={DARSHAN_LOGO} alt="Darshan Uniforms" style={{
                    height: 36, width: "auto", display: "block",
                    objectFit: "contain", flexShrink: 0,
                }} />

                {/* Vertical divider */}
                <div style={{
                    width: 1, height: 28, flexShrink: 0,
                    background: "linear-gradient(180deg, transparent 0%, #D6CFC2 30%, #D6CFC2 70%, transparent 100%)",
                }} />

                {/* Product name */}
                <div style={{
                    display: "flex", flexDirection: "column",
                    justifyContent: "center", gap: 1,
                    minWidth: 0, flexShrink: 1,
                }}>
                    <span style={{
                        fontSize: 13, fontWeight: 800, color: "#1F2937",
                        letterSpacing: "0.14em", textTransform: "uppercase", lineHeight: 1.1,
                    }}>
                        Garment ERP
                    </span>
                    <span style={{
                        fontSize: 9.5, fontWeight: 600, color: BRAND_TO,
                        letterSpacing: "0.18em", textTransform: "uppercase", lineHeight: 1.1,
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                    }}>
                        Production · Inventory · Billing
                    </span>
                </div>

                <div style={{ flex: 1 }} />

                {/* Developer credit */}
                <div style={{
                    display: "flex", alignItems: "center", gap: 10,
                    flexShrink: 0,
                }}>
                    <span style={{
                        fontSize: 8.5, fontWeight: 600, color: "#9CA3AF",
                        letterSpacing: "0.10em", textTransform: "uppercase", lineHeight: 1.1,
                    }}>
                        Developed by
                    </span>
                    <img src={SMIT_LOGO} alt="SMIT — Solapurmall Information Technology Pvt. Ltd." style={{
                        height: 22, width: "auto", display: "block",
                    }} />
                </div>
            </div>

            {/* Bottom accent stripe */}
            <div style={{
                height: 2,
                background: `linear-gradient(90deg, ${BRAND_FROM} 0%, ${BRAND_TO} 50%, ${BRAND_FROM} 100%)`,
            }} />
        </div>
    );
}
